export default __webpack_public_path__ + "static/media/DraculaVoice.3ffb8432.svg";